import { render, staticRenderFns } from "./litepage.vue?vue&type=template&id=51e67374&scoped=true&"
import script from "./litepage.vue?vue&type=script&lang=js&"
export * from "./litepage.vue?vue&type=script&lang=js&"
import style0 from "./litepage.vue?vue&type=style&index=0&id=51e67374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e67374",
  null
  
)

export default component.exports